import {
  AnalyticsOutlined,
  CloudCircleOutlined,
  Inventory2Outlined,
  MonetizationOnOutlined,
} from "@mui/icons-material";
import ClientManagementIcon from "../../assets/Icons/navigation-icon/ClientManagementIcon";
import LandlordIcon from "../../assets/Icons/navigation-icon/LandlordIcon";
import ProfileIcon from "../../assets/Icons/navigation-icon/ProfileIcon";
import UserManagementIcon from "../../assets/Icons/navigation-icon/UserManagementIcon";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const SHAREPOINT_URL = import.meta.env.VITE_SHAREPOINT_URL;
const POWER_BI_URL = import.meta.env.VITE_POWER_BI_URL;

export const sideBarContentAdmin = [
  {
    pageName: "Landlord Cost Sharing Agreement",
    navMenuName: "Landlord Cost Sharing Agreement",
    sideNavIcon: <LandlordIcon />,
    activeSideNavIcon: <LandlordIcon />,
    id: 4,
    pageRoute: "/landlords",
    page: "/landlords",
  },
  {
    pageName: "Add New Farm Details",
    navMenuName: "Add New Farm Details",
    sideNavIcon: <ClientManagementIcon />,
    activeSideNavIcon: <ClientManagementIcon />,
    id: 5,
    pageRoute: "/add-new-farm",
    page: "/add-new-farm",
  },
  {
    pageName: "Landlord to Fields Mapping",
    navMenuName: "Landlord to field Mapping",
    sideNavIcon: <UserManagementIcon />,
    activeSideNavIcon: <UserManagementIcon />,
    id: 6,
    pageRoute: "/landlord-field-mapping",
    page: "/landlord-field-mapping",
  },
  {
    pageName: "Landlord Bills",
    navMenuName: "Landlord Bills",
    sideNavIcon: <ReceiptLongIcon sx={{ color: "#5F5C5C" }} />,
    activeSideNavIcon: <ReceiptLongIcon sx={{ color: "#5F5C5C" }} />,
    pageRoute: "/landlord-bills",
    id: 8,
    page: "/landlord-bills",
  },
  {
    pageName: "Pricing Module",
    navMenuName: "Pricing Module",
    sideNavIcon: (
      <MonetizationOnOutlined sx={{ color: "rgba(0, 0, 0, 0.7)" }} />
    ),
    activeSideNavIcon: <MonetizationOnOutlined />,
    pageRoute: "/pricing-costs",
    id: 12,
    page: "/pricing-costs",
  },
  {
    pageName: "Inventory Management",
    navMenuName: "Inventory Management",
    sideNavIcon: (
      <Inventory2Outlined sx={{ color: "rgba(0, 0, 0, 0.7)" }} />
    ),
    activeSideNavIcon: <Inventory2Outlined />,
    pageRoute: "/inventory-management",
    id: 13,
    page: "/inventory-management",
  },
  {
    pageName: "Power BI Dashboard",
    navMenuName: "Power BI Dashboard",
    sideNavIcon: <AnalyticsOutlined />,
    activeSideNavIcon: <AnalyticsOutlined />,
    id: 10,
    pageRoute: "",
    page: "",
    externalLink: POWER_BI_URL as string,
  },
  {
    pageName: "SharePoint",
    navMenuName: "SharePoint",
    sideNavIcon: <CloudCircleOutlined />,
    activeSideNavIcon: <CloudCircleOutlined />,
    id: 11,
    pageRoute: "",
    page: "",
    externalLink: SHAREPOINT_URL as string,
  },
  {
    pageName: "User Profile",
    navMenuName: "User Profile",
    sideNavIcon: <ProfileIcon />,
    activeSideNavIcon: <ProfileIcon />,
    id: 9,
    pageRoute: "/user-profile",
    page: "/user-profile",
  },
];
